import React from 'react';

const InfoItem = ({label, value}: {label: string; value: number | string}) => (
    <dl data-testid="info-item">
        <dt
            className="overline-regular"
            style={{whiteSpace: 'nowrap'}}
        >
            {label}
        </dt>
        <dd className="title-small">{value}</dd>
    </dl>
);

export default InfoItem;
